import React, { useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";

export const useSSLCommerzPay = (data) => {


    const shurjoPayData = data;
    const [sslCommerzBuffer, setSSLCommerzBuffer] = useState(false)
    let history = useHistory()


    const sslCommerzPayMakePayment = () => {
        setSSLCommerzBuffer(true)

        axios.post("/api/init-sslcommerz", shurjoPayData, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'text/json',
                'Access-Control-Allow-Origin': ' http://localhost:3000',
                'Access-Control-Allow-Credentials': 'true',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Headers': 'Origin, Content-Type, Accept'
            }
        })
        .then(async (res) => {
        setSSLCommerzBuffer(false)

        setTimeout(() => {
            window.location.href  = res?.data?.data
        }, 1500);

            // history.push({
            //     pathname:  '/sslCommerz-pay',
            //     state: {
            //         url: res?.data?.data
            //     }// your data array of objects
            // })
        }).catch(err => {
            setSSLCommerzBuffer(false)
        });


    }

    return { sslCommerzPayMakePayment, sslCommerzBuffer }
}
